
import { RefObject } from 'react';
import * as THREE from 'three';

/**
 * Handles window resize events
 */
export const setupResizeHandler = (
  cameraRef: RefObject<THREE.PerspectiveCamera>,
  rendererRef: RefObject<THREE.WebGLRenderer>,
  setWindowSize: (size: { width: number, height: number }) => void
) => {
  const handleResize = () => {
    if (!cameraRef.current || !rendererRef.current) return;

    const width = window.innerWidth;
    const height = window.innerHeight;

    // Update state
    setWindowSize({ width, height });

    // Update camera
    cameraRef.current.aspect = width / height;
    cameraRef.current.updateProjectionMatrix();

    // Update renderer
    rendererRef.current.setSize(width, height);
  };

  return handleResize;
};

/**
 * Setup mouse movement handler for interactive effects
 */
export const setupMouseHandler = (
  setMousePosition: (position: { x: number, y: number }) => void
) => {
  const handleMouseMove = (event: MouseEvent) => {
    // Normalize mouse position between -1 and 1
    const x = (event.clientX / window.innerWidth) * 2 - 1;
    const y = -(event.clientY / window.innerHeight) * 2 + 1;
    
    setMousePosition({ x, y });
  };

  return handleMouseMove;
};
